// extracted by css-extract-rspack-plugin
export default {"actionsRow":"BHhXR_dV8YceV5mV"};